import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { CreateTrainingsTrainingClassAttachmentsInput } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import {
  getBorder,
  getBorderRadius,
} from 'modules/trainings/components/Revamp/NewClassWizard/AttachmentsStep/AttachmentsList/useBorderRadiusUtilities'

interface Props {
  attachments: CreateTrainingsTrainingClassAttachmentsInput[]
  onDelete: (value: number) => void
}

export const AttachmentsList = ({ attachments, onDelete }: Props) => {
  return (
    <Box gap="s16">
      <Box>
        {attachments.map((file, index) => {
          return (
            <Box
              key={index}
              borderRadius={getBorderRadius(index, attachments.length)}
              border={getBorder(index, attachments.length)}
              padding="s24"
              justifyContent="spaceBetween"
              flexDirection="row"
              alignItems="center"
            >
              <Box flexDirection="row" alignItems="center" gap="s8">
                <DocumentType mimetype={file.file.type} />
                <Text size="300">{file.title || file.file.name}</Text>
              </Box>
              <PopoverMenu type="list">
                <PopoverMenu.Trigger>
                  <Button
                    type="secondary"
                    onClick={(e) => e.preventDefault()}
                    iconName="ellipsis"
                  />
                </PopoverMenu.Trigger>
                <PopoverMenu.Content side="bottom" align="end">
                  <PopoverMenu.TouchableOption
                    danger
                    title={i18n.t('trainings.session_access_membership_table.upload_files_delete')}
                    onClick={() => onDelete(index)}
                    icon="delete"
                  />
                </PopoverMenu.Content>
              </PopoverMenu>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
